import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description CalendarSimple icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { CalendarSimple } from '@sravni/design-system-icons'
 *
 * <CalendarSimple />
 * ```
 */
var CalendarSimple = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "CalendarSimple", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("rect", { x: "2.75", y: "3.75", width: "14.5", height: "13.5", rx: "1.25", stroke: "currentColor", strokeWidth: "1.5" }),
    React.createElement("rect", { x: "2", y: "7.5", width: "16", height: "1.5", rx: ".75", fill: "currentColor" }),
    React.createElement("rect", { x: "6", y: "2", width: "1.5", height: "4", rx: ".75", fill: "currentColor" }),
    React.createElement("rect", { x: "12.5", y: "2", width: "1.5", height: "4", rx: ".75", fill: "currentColor" }))); });

export { CalendarSimple };
//# sourceMappingURL=CalendarSimple.js.map
